<app-form-app titleForm="Edit App" (onSubmit)="save($event)" #form [mode]="AppFormMode.EDITION">
    <ng-template let-form>
        <div class="d-flex align-items-center mt-3">
            <button mat-raised-button color="primary" mat-raised-button type="submit" [disabled]="saving">
                Update Application
            </button>
            @if (saving) {
                <mat-spinner diameter="20" class="ms-1"></mat-spinner>
            }
        </div>
    </ng-template>
</app-form-app>
